
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css'; 

function App() {
  const [formData, setFormData] = useState({ name: '', age: '', symptoms: '' });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [view, setView] = useState('patient'); // Toggle: 'patient' or 'admin'

  // ⚠️ USE YOUR RENDER URL
  const BASE_URL = "https://care-connect-server-ru9l.onrender.com"; 

  // Function to fetch the Log
  const fetchAppointments = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/appointments`);
      setAppointments(res.data);
    } catch (err) { console.error(err); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/api/predict`, formData);
      setResult(res.data.data);
      fetchAppointments(); // Refresh log immediately
    } catch (error) {
      alert("Backend Error");
    }
    setLoading(false);
  };

  // Auto-fetch logs when admin view is opened
  useEffect(() => {
    if(view === 'admin') fetchAppointments();
  }, [view]);

  return (
    <div className="app-container">
      <nav className="navbar">
        <div className="nav-content">
          <div className="logo">🏥 MEDI-CONNECT AI</div>
          <div>
            <button onClick={() => setView('patient')} className="nav-btn">Patient View</button>
            <button onClick={() => setView('admin')} className="nav-btn">Receptionist Log</button>
          </div>
        </div>
      </nav>

      <div className="main-content">
        
        {/* VIEW 1: PATIENT FORM */}
        {view === 'patient' && (
          <div className="card">
            <h2 className="title">AI Triage Check-In</h2>
            <form onSubmit={handleSubmit}>
              <input type="text" placeholder="Name" required onChange={e=>setFormData({...formData, name:e.target.value})}/>
              <input type="number" placeholder="Age" required onChange={e=>setFormData({...formData, age:e.target.value})}/>
              <textarea rows="3" placeholder="Symptoms..." required onChange={e=>setFormData({...formData, symptoms:e.target.value})}/>
              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? "AI Analysis in Progress..." : "Submit for Triage"}
              </button>
            </form>
            {result && (
              <div className={`result-box ${result.severity}`}>
                <h3>Result: {result.severity}</h3>
                <p>Please see a <strong>{result.specialist}</strong>.</p>
              </div>
            )}
          </div>
        )}

        {/* VIEW 2: RECEPTIONIST LOG (SORTED) */}
        {view === 'admin' && (
          <div className="log-container">
            <h2>Live Patient Queue (Sorted by Severity)</h2>
            <table className="log-table">
              <thead>
                <tr>
                  <th>Risk Score</th>
                  <th>Name</th>
                  <th>Severity</th>
                  <th>Dept</th>
                  <th>Symptoms</th>
                </tr>
              </thead>
              <tbody>
                {appointments.map((appt) => (
                  <tr key={appt.id} className={appt.analysis.severity}>
                    <td>{appt.analysis.risk_score}/10</td>
                    <td>{appt.name}</td>
                    <td>{appt.analysis.severity}</td>
                    <td>{appt.analysis.specialist}</td>
                    <td>{appt.symptoms}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

      </div>
    </div>
  );
}

export default App;
